module.exports = __webpack_public_path__ + "static/media/DouvitLogo.cbe955cb.svg";